import React from 'react';
import {Link} from "react-router-dom";
import user from '../../Content/Img/user.svg';

import lefthome from '../../Content/Img/Dashboard.svg';

import leftprofile from '../../Content/Img/myprofile.svg';

import leftchangepassword from '../../Content/Img/changepassword.svg';
import Leftgr from '../../Content/Img/awbtrack.svg';
import dashboardgr from '../../Content/Img/grdashboard.svg';
import dashboarddeleverytrack from '../../Content/Img/task.svg';
import Leftdeleverytrack from '../../Content/Img/delivery.svg';

import leftpod from '../../Content/Img/pod.svg';
import dashboardpod from '../../Content/Img/poddashboard.svg';

//import ReactWhatsapp from 'react-whatsapp';





import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars,faPhoneAlt,faWindowClose } from '@fortawesome/free-solid-svg-icons'
import * as Constant from '../../Utilities/Constant';
import { callApi,APIcustomerID } from '../../Utilities/Api'
import Footer from '../Shared/Footer';
import Logout from '../Logout/Logout';

class Home extends React.Component{
    constructor(props) {
        super(props);
        this.state = {isMobileMenu: false};
        this.state={FirstName:'',LastName:'',MobileNumber:'',EmailID:''}
        this.handleChangeMenu = this.handleChangeMenu.bind(this);
      }
      
      handleChangeMenu() {
        this.setState(prevState => ({
            isMobileMenu: !prevState.isMobileMenu
          }));
          console.log(this.state.isMobileMenu)
          
      }
      componentDidMount() {
        
        if(APIcustomerID()!=null)
        {
            
            const requestData={customerid:APIcustomerID()}
            const ProfileDetails=callApi("POST",requestData,Constant.CustomerDetails);
            ProfileDetails.then((responseData)=>{

           
            responseData.DataResponse.forEach(team => 
              {
                
                
                this.setState({FirstName:team.FirstName,
                 LastName:team.LastName,
                 MobileNumber:team.MobileNo,
                 EmailID:team.EmailID
                
             });
               

                  
            });
        
                });
        }
     
      }
    render(){
        return(
            <div className="App">
            <header>
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-8">
                <button className="toggle_btn" onClick={this.handleChangeMenu} >
                { (this.state.isMobileMenu > 0) ? 
                 (
                    <FontAwesomeIcon icon={faWindowClose} />
                 ) : <FontAwesomeIcon icon={faBars} /> } 
                

                     </button>
                  
                    <h1>
                        Dasboard
                    </h1>
                   <Logout></Logout>
                </div>
            </div>
        </div>
    </header>

    { (this.state.isMobileMenu > 0) ? 
                 (
                    <aside>
                    <div className="prof">
                        <span>NSSL</span>
                       
                    </div>
                    <ul>
            
                        <li className="active home">
                        <Link to="/app/dashboard"  >
                        <img src={lefthome} alt="mobile login" />
                                <span>Dashboard</span>
                        </Link>
                            
                        </li>
                        <li>
                        <Link to="/app/awb/track"  >
                        <img src={Leftgr} alt='AWB Track' />
                                <span>AWB Track</span>
                        </Link>
                           
                        </li>
                        <li>
                        <Link to="/app/delivery/update"  >
                            <img src={Leftdeleverytrack} alt='Delivery Update' />
                                    
                                    <span>
                                    Delivery Update
                                    </span>
                            </Link>
                       
                          
                        </li>
                        <li>
                        <Link to="/app/pod/upload"  >
                            <img src={leftpod} alt='POD Upload' />
                                    
                                    <span>
                                    POD Upload
                                    </span>
                            </Link>
                        
                          
                        </li>
                       
                    </ul>
                   
                    <h4>
                        Others
                    </h4>
                    <ul>
                        <li>
                        <Link to="/app/profile/changepassword"  >
                        <img src={leftchangepassword} alt="report" />
                                <span>Change Password</span>
                        </Link>
                            
                        </li>
                        <li>
                        <Link to="/app/profile"  >
                        <img src={leftprofile} alt="report" />
                                <span>Profile</span>
                        </Link>
                            
                        </li>
                        {/* <li>
                        <Link to="/app/tickets/create"  >
                        <img src={leftreporthelpcenter} alt="report" />
                                <span>Help Center</span>
                        </Link>
                           
                        </li>
                        <li>
                        <Link to="/app/tickets"  >
                        <img src={lefttickets} alt="report" />
                                <span>Tickets</span>
                        </Link>
                          
                        </li> */}
                        <li>

                        {/* <Logout /> */}
                           
                        </li>
                    </ul>
                </aside>
                 ) : <div></div> }
   

    <section>
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="profile_box">
                        <figure>
                        <img src={user} alt="mobile login" />
                        </figure>
                        <div className="det">
                            <h2>
                                {this.state.FirstName} {this.state.LastName}
                            </h2>
                            <h3>
                                {this.state.MobileNumber}
                            </h3>
                            <h3>{this.state.EmailID}</h3>
                           
                        </div>
                    </div>
                </div>
                <div className="col-md-8">
                    <div className="row service_list">
                        <div className="col-6 col-sm-4 col-lg-3">
                            <div className="box">
                            <Link to="/app/awb/track"  >
                            <img src={dashboardgr} alt='AWB Track' />
                                    <h4>
                                        AWB Track
                                    </h4>
                            </Link>
                               
                            </div>
                        </div>
                        <div className="col-6 col-sm-4 col-lg-3">
                            <div className="box">
                            <Link to="/app/delivery/update"  >
                            <img src={dashboarddeleverytrack} alt='Delivery Update' />
                                    
                                    <h4>
                                    Delivery Update
                                    </h4>
                            </Link>
                             
                            </div>
                        </div>
                        <div className="col-6 col-sm-4 col-lg-3">
                            <div className="box">
                            <Link to="/app/pod/upload"  >
                            <img src={dashboardpod} alt='POD Upload' />
                                    
                                    <h4>
                                    POD Upload
                                    </h4>
                            </Link>
                               
                            </div>
                        </div>
                       
                        
                    </div>
                </div>
                {/* <div className="col-md-8">
                    <div className="service_list">
                        <div className="box">
                        <p className="alertnote">Call us
                        <a href="tel:+919313806520" >  <FontAwesomeIcon icon={faPhoneAlt} /> +91-9313806520</a>
                        <br/>
                        <br/>
                        <ReactWhatsapp number="+91-9313806520" message="Hello !!!"  className="blue_btn" >Whatsapp</ReactWhatsapp>
                     


                           </p>
                        </div>
                    </div>
                    
                </div> */}
            </div>
        </div>
    </section>

    <Footer />
      
            </div>

            
        )
    }

}
export default Home;